const handler = ( $ ) => {
	$( document ).ready( function () {
		if ( !$( '.hero-section' ).length ) {
			$( 'header' ).addClass( 'has-hero' );
		}
		const $body = $( 'body' );
		const $toggleButton = $( '#mobile-menu-toggle' );
		const $mainMenu = $( '#main-menu' );

		if ( $toggleButton.length === 0 || $mainMenu.length === 0 ) {
			console.error(
				'Required menu elements not found in the DOM: #mobile-menu-toggle or #main-menu.'
			);
			return;
		}
		const $servicesMenuItem = $mainMenu.find( '.menu-item-has-children' );
		const $servicesMenuTitle = $servicesMenuItem.find( '> .menu-title' );
		const $servicesSubMenu = $servicesMenuItem.find( '.sub-menu' );
		// Function to handle opening and closing the menu
		function toggleMenu() {
			$body.toggleClass( 'menu-open' );
			$( '.main-menu' ).toggleClass( 'is-hidden' );
			const isExpanded = $body.hasClass( 'menu-open' );

			if ($( window ).width() < 768 && ! isExpanded && $servicesMenuItem.hasClass( 'active' ) ) {
				$servicesMenuItem.removeClass( 'active' );

				$( '.main-menu' ).removeClass( 'sub-menu-open' );
				$servicesSubMenu.slideToggle( 500 );
			}
			// Update the ARIA attribute on the toggle button
			$toggleButton.attr( 'aria-expanded', isExpanded );

			$toggleButton.focus();
		}
		function hideMenu() {
			const isExpanded = $body.hasClass( 'menu-open' );
			if ( $( window ).width() < 768 ) {
				if ( ! isExpanded ) {
					$( '.main-menu' ).addClass( 'is-hidden' );
				}
			} else {
				$( '.main-menu' ).removeClass( 'is-hidden' );
			}
		}
		let resizeTimer;
		$( window ).on( 'resize', function () {
			clearTimeout( resizeTimer );
			resizeTimer = setTimeout( hideMenu, 100 );
		} );

		hideMenu();
		$toggleButton.on( 'click', function ( e ) {
			toggleMenu();
		} );
		$( document ).on( 'keydown', function ( e ) {
			if ( e.key === 'Escape' && $body.hasClass( 'menu-open' ) ) {
				toggleMenu();
				// Prevent default behavior (like browser back/forward)
				e.preventDefault();
			}
		} );

		$servicesSubMenu.hide();

		if ( $servicesMenuTitle.length ) {
			$servicesMenuTitle.on( 'click', function ( e ) {
				e.preventDefault();
				$servicesMenuItem.toggleClass( 'active' );
				$servicesSubMenu.slideToggle( 500 );
				$( '.main-menu' ).toggleClass( 'sub-menu-open' );
			} );
		}
		$mainMenu.find( 'a' ).on( 'click', function () {
			const $link = $( this );
			const $parentLi = $link.closest( 'li' );
			if (
				! $parentLi.hasClass( 'menu-item-has-children' ) ||
				$parentLi.closest( '.sub-menu' ).length > 0
			) {
				if ( $body.hasClass( 'menu-open' ) ) {
					toggleMenu();
				}
			}
		} );

		var $dropdownParents = $( '.menu-item-has-children' );
		var $subMenus = $dropdownParents.find( '.sub-menu' );

		$( window ).scroll( function () {
			if ( $dropdownParents.hasClass( 'active' ) ) {
				$dropdownParents.removeClass( 'active' );
				$subMenus.slideUp( 300 );
				$( '.main-menu' ).toggleClass( 'sub-menu-open' );
			}
		} );

		$( '.main-menu .sub-menu li' ).on( 'click', function ( e ) {
			const link = $( this ).find( 'a' ).attr( 'href' );
			if ( link ) {
				window.location.href = link;
			}
		} );
	} );
};

export default ( ( $ ) => $( handler ) )( jQuery );
